// extracted by mini-css-extract-plugin
export default {"header":"style_header__A5IaU","title":"style_title__P3OSa","content":"style_content__caJya"};